<ng-container [ngSwitch]="type">
  <ng-container *ngSwitchCase="'currency'">
    <ng-container *ngTemplateOutlet="currencyMaskFieldTmpl"></ng-container>
  </ng-container>

  <ng-container *ngSwitchCase="'percentage'">
    <ng-container *ngTemplateOutlet="currencyMaskFieldTmpl"></ng-container>
  </ng-container>

  <input
    *ngSwitchCase="'number'"
    matInput
    [locktonAppsClearOnFocus]="props.readonly ? 'disabled' : props.clearOnFocus"
    [id]="id"
    [name]="field.name || ''"
    [readonly]="props.readonly"
    [required]="required"
    [errorStateMatcher]="errorStateMatcher"
    [formControl]="formControl"
    [formlyAttributes]="field"
    [tabIndex]="props.tabindex"
    [placeholder]="props.placeholder || ''"
    type="number"
    onwheel="this.blur()"
  />
  <input
    *ngSwitchDefault
    matInput
    [locktonAppsClearOnFocus]="props.readonly ? 'disabled' : props.clearOnFocus"
    [id]="id"
    [name]="field.name || ''"
    [type]="type || 'text'"
    [readonly]="props.readonly"
    [required]="required"
    [errorStateMatcher]="errorStateMatcher"
    [formControl]="formControl"
    [formlyAttributes]="field"
    [tabIndex]="props.tabindex"
    [placeholder]="props.placeholder || ''"
    [autocomplete]="props.autocomplete || 'off'"
    [mask]="props.mask"
    [thousandSeparator]="props.thousandSeparator || ','"
  />
</ng-container>

<ng-template #currencyMaskFieldTmpl>
  <input
    matInput
    [locktonAppsClearOnFocus]="props.readonly ? 'disabled' : props.clearOnFocus"
    [id]="id"
    [name]="field.name || ''"
    [type]="'text'"
    [readonly]="props.readonly"
    [required]="required"
    [errorStateMatcher]="errorStateMatcher"
    [formControl]="formControl"
    [formlyAttributes]="field"
    [tabIndex]="props.tabindex"
    [placeholder]="props.placeholder || ''"
    [autocomplete]="props.autocomplete || 'off'"
    luiCurrencyMask
    [currencyOptions]="props.currencyOptions"
  />
</ng-template>
